import React from "react";
import styled from "styled-components";
import { Carousel } from "antd";
import { HeartFilled } from "@ant-design/icons";
import { data } from "../data/data";

const BannerWrapper = styled.div`
  min-height: 500px;
  /* position: relative;
  right: 0;
  left: 0; */
  margin-top: -140px;
  /* bottom: 0; */
  z-index: 1;
  .caro-bg,
  .caro-bg-2,
  .caro-bg-1 {
    /* background: url(${(props) => props.imgUrl}); */
    background-blend-mode: multiply;
    @media (max-width: 768px) {
      background-position: 55% 30%;
      object-fit: fill;
      text-align: center;
      height: 790px;
      padding-bottom: 80px;
    }
  }
  @media (max-width: 320px) {
    .caro-bg,
    .caro-bg-1,
    .caro-bg-2 .slick-dot {
      display: none;
    }
  }
  .banner-content {
    position: relative;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    height: 100%;
    font-family: "Pacifico", cursive;
    text-transform: capitalize;
    color: white;
    @media (max-width: 768px) {
      top: 140px;
    }
  }
  .pink-dot {
    color: #f0394d;
  }
  .date {
    font-size: 47px;
    line-height: 40px;
    transform: rotate(-10deg);
    @media (max-width: 767px) {
      font-size: 280%;
      line-height: 30px;
      transition: 0.5s ease-in-out;
    }
  }
  .save {
    font-size: 75px;
    line-height: 50px;
    color: #fff;
    transform: rotate(-10deg);
    @media (max-width: 767px) {
      font-size: 290%;
      line-height: 36px;
      transition: 0.5s ease-in-out;
    }
  }
  .the-date {
    font-size: 62px;
    color: #fff;
    transform: rotate(-10deg);
    @media (max-width: 767px) {
      font-size: 280%;
      line-height: 40px;
      transition: 0.5s ease-in-out;
    }
  }
  .banner-text.light {
    color: #fff;
    border-top: medium double #fff;
    border-bottom: medium double #fff;
    letter-spacing: 3px;
  }
  .banner-text.medium {
    padding: 2px 50px;
    @media (max-width: 320px) {
      padding: 2px 30px important;
    }
  }
  .banner-text h3 {
    color: white;
  }
  .banner-text {
    display: inline-block;
    font-family: "Oswald", sans-serif;
    margin: auto;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
    color: white;
    @media (max-width: 320px) {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 80%;
    }
  }
  .heart-divider {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
  }
  .white-line {
    width: 30px;
    height: 8px;
    display: inline-block;
    border-top: solid 1px #fff;
    margin: 0 3.5px;
  }
  .date-wrap {
    margin: 25px 0;
  }

  @media (max-width: 320px) {
    .ant-carousel .slick-dots {
      opacity: 0;
    }
  }
`;

export default function Banner(props) {
  return (
    <BannerWrapper>
      <Carousel effect="fade" autoplay>
        {data &&
          data.map((slide) => (
            <div
              className="caro-bg"
              key={slide.id}
              style={{ background: `${slide.imgUrl}` }}
            >
              <div className="banner-content">
                <div className="date-wrap">
                  {" "}
                  <div className="save">save</div>
                  <div className="the-date">the date</div>
                  <div className="date">
                    - 19<span className="pink-dot">.</span>12
                    <span className="pink-dot">.</span>21 -
                  </div>
                </div>
                <div>
                  <div className="banner-text medium light">
                    <h3>*** WE ARE GETTING MARRIED ***</h3>
                  </div>
                  <div className="heart-divider">
                    <span className="white-line"></span>
                    <HeartFilled
                      className="pink-dot"
                      style={{ fontSize: 18, zIndex: 20 }}
                    />
                    <HeartFilled style={{ fontSize: 20, marginLeft: -5 }} />
                    <span className="white-line"></span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        <div className="caro-bg-1">
          <div className="banner-content">
            <div className="date-wrap">
              <div className="save">save</div>
              <div className="the-date">the date</div>
              <div className="date">
                - 19<span className="pink-dot">.</span>12
                <span className="pink-dot">.</span>21 -
              </div>
            </div>
            <div>
              <div className="banner-text medium light">
                <h3>*** WE ARE GETTING MARRIED ***</h3>
              </div>
              <div className="heart-divider">
                <span className="white-line"></span>
                <HeartFilled
                  className="pink-dot"
                  style={{ fontSize: 18, zIndex: 20 }}
                />
                <HeartFilled style={{ fontSize: 20, marginLeft: -5 }} />
                <span className="white-line"></span>
              </div>
            </div>
          </div>
        </div>
        <div className="caro-bg-2">
          {" "}
          <div className="banner-content">
            <div className="date-wrap">
              <div className="save">save</div>
              <div className="the-date">the date</div>
              <div className="date">
                - 19<span className="pink-dot">.</span>12
                <span className="pink-dot">.</span>21 -
              </div>
            </div>
            <div>
              <div className="banner-text medium light">
                <h3>*** WE ARE GETTING MARRIED ***</h3>
              </div>
              <div className="heart-divider">
                <span className="white-line"></span>
                <HeartFilled
                  className="pink-dot"
                  style={{ fontSize: 18, zIndex: 20 }}
                />
                <HeartFilled style={{ fontSize: 20, marginLeft: -5 }} />
                <span className="white-line"></span>
              </div>
            </div>
          </div>
        </div>
      </Carousel>
    </BannerWrapper>
  );
}
